import styled from '@emotion/styled'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'
import { Asable } from '../../types/asable'
import { getShadow } from '../../utils/getShadow'
import { tileSizeToStyles } from './constants/tileSizeToStyles'
import { TileSize } from './types/tileSize'

interface TileWrapperProps extends Asable {
  isClickable?: boolean
  size?: TileSize
}

export const TileWrapper = styled.div<TileWrapperProps>`
  display: flex;
  justify-content: center;
  padding: ${Spacing.S12};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  ${getShadow('raisedLight')};
  ${({ size }) => size && tileSizeToStyles[size]};
  overflow: hidden;

  &:hover {
    background-color: ${Color.Grey150};
    ${({ isClickable }) => isClickable && `cursor: pointer;`};
  }

  &:active {
    background-color: ${Color.Grey200};
  }
`
